var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`delta-overlay ${_vm.classes}`},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.delta > 0)?_c('sup',{class:`delta-overlay__delta ${_vm.delta_classes}`},[_c('span',[_vm._v(" +"+_vm._s(_vm.delta)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }